<template>
  <div id="app">
    <PageHeaderMobile />
    <PageHeader v-if="pageHeaderShow && !vuex_h5" />
    <Nav v-if="navShow && !vuex_h5" />
    <div class="main-box">
      <router-view></router-view>
    </div>
    <PageFooter />
  </div>
</template>

<script>
import PageHeaderMobile from "@/components/page_header_mobile.vue";
import PageHeader from "@/components/pageHeader.vue";
import Nav from "@/components/nav.vue";
import PageFooter from "@/components/pageFooter.vue";
import disease from "@/views/disease.json";
export default {
  name: "App",
  components: {
    PageHeaderMobile,
    PageHeader,
    Nav,
    PageFooter,
  },
  data() {
    return {
      pageHeaderShow: true,
      navShow: true,
      breadcrumbArr: [],
      categoryOptions: [],
    };
  },
  //监听属性 类似于data概念
  computed: {},
  //监控data中的数据变化
  watch: {
    $route(to, from) {
      if (to.path.includes("/search")) {
        this.pageHeaderShow = false;
        this.navShow = false;
      } else {
        this.pageHeaderShow = true;
        this.navShow = true;
      }
      // 切换页面时自动回到顶部
      if (to.path != from.path) {
        scrollTo(0, 0);
      }
    },
  },
  //方法集合
  methods: {},
  //生命周期 - 创建完成（可以访问当前this实例）
  created() {},
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {},
};
</script>



<style lang="scss">
  img{
     object-fit: contain;
  }
.hover-color {
  cursor: pointer;
}
.hover-color:hover {
  color: #3878f8 !important;
}
img {
  // object-fit: cover;
  
}

.ellipsis-1 {
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}
.ellipsis-2 {
  display: -webkit-box;
  -webkit-box-orient: vertical;
  text-overflow: ellipsis;
  overflow: hidden;
  -webkit-line-clamp: 2;
}
.ellipsis-3 {
  display: -webkit-box;
  -webkit-box-orient: vertical;
  text-overflow: ellipsis;
  overflow: hidden;
  -webkit-line-clamp: 3;
}
.ellipsis-4 {
  display: -webkit-box;
  -webkit-box-orient: vertical;
  text-overflow: ellipsis;
  overflow: hidden;
  -webkit-line-clamp: 4;
}
.ellipsis-5 {
  display: -webkit-box;
  -webkit-box-orient: vertical;
  text-overflow: ellipsis;
  overflow: hidden;
  -webkit-line-clamp: 5;
}
@media screen and (max-width: 768px) {
  .main-box {
    padding-top: 50px;
  }
}
</style>

<style lang="scss" scoped>
//@import url("../src/assets/css/index.scss");

#app {
  //min-width: 1900px;
  height: 100%;
  background: #f5f6f9;
}

.main-box {
  background: #f5f6f9;
  padding-bottom: 20px;
}
</style>
